var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('bo-page-title'),_c('BoUserForm',_vm._b({attrs:{"row":_vm.row,"is-account-setting":true},on:{"update:row":function($event){_vm.row=$event}}},'BoUserForm',_vm.passToSubComp,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }